export default () => ({
  isDraftsFetched: false,
  drafts: [],
  isPublishing: false,
  currentlyPublishingDrafts: [],
  shouldAnimateReviewButton: false,
  isMergeRequest: false,
});
